import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { contact_usComponent } from './pages/contact_us/contact_us.component';
import { FaqComponent } from './pages/faq/faq.component';
import { HomeComponent } from './pages/home/home.component';
import { ResourcesComponent } from './pages/resources/resources.component';
import { salaryScaleComponent } from './pages/salaryScale/salaryScale.component';
import { DutyStationSalaryScaleComponent } from './pages/dutystation_salaryscale/dutystation_salaryscale.component'
import { special_measuresComponent } from './pages/special_measures/special_measures.component';
import { survey_scheduleComponent } from './pages/survey_schedule/survey_schedule.component';
import { trainingComponent } from './pages/training/training.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'salary_scale',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'salary_scale',
    component: salaryScaleComponent
  },
  {
    path: 'viewdutystation/:id',
    component: DutyStationSalaryScaleComponent
  },
  {
    path: 'resources',
    component: ResourcesComponent
  },
  {
    path: 'survey_schedule',
    component: survey_scheduleComponent
  },
  {
    path: 'training',
    component: trainingComponent
  },
  {
    path: 'special_measures',
    component: special_measuresComponent
  },
  {
    path: 'contact_us',
    component: contact_usComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
];

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, { useHash: true })], // { useHash: true }
  exports: [RouterModule]
})
export class AppRoutingModule { }
